import './block/accordion/accordion';
import './block/hero-splitscreen/hero-splitscreen';
import './block/news-nexipedia-reference-teaser/news-nexipedia-reference-teaser';
import './block/quick-facts/quick-facts';
import './block/tag-cloud/tag-cloud';
import './block/text-iconlist/text-iconlist';
import './component/embla-carousel/embla-carousel';
import './component/footer/footer';
import './component/header/header';

document.addEventListener("click", function(e) {
  const link = e.target.closest("a[href^='#action-']");
  if (!link) return;

  e.preventDefault();

  const action = link.getAttribute("href").replace("#action-", "");

  switch (action) {
    case "cookiebot-renew":
      if (typeof Cookiebot !== "undefined") {
        Cookiebot.renew();
      }
      break;
  }
});
